import React, { useState, useEffect } from 'react'
import DotLoader from '../../Loader/DotLoader.component'
import { GetUserCommunicationTypeByDate, GetUserCommunicationCountTypeByDate, getAppUsercommunicationLogsList } from '../../../containers/Admin/AdminActionCreator.component';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';

const itemsPerPage = 7;

const dayObj = [
    { name: "M", value: "monday", },
    { name: "T", value: "tuesday", },
    { name: "W", value: "wednusday", },
    { name: "T", value: "thursday", },
    { name: "F", value: "friday", },
    { name: "S", value: "saturday", },
    { name: "S", value: "sunday", },
]

export default function CommunicationDetailPopupAllApplications({ handleLogListPopup }) {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const [serviceType, setServiceType] = useState('main');
    const [LogListPopup, setLogListPopup] = useState({
        ListData: [],
        totalCount: 0,
        currentPage: 1,
        commType: '',
        startDate: fromDate,
        endDate:toDate
    });

    const [showCommServiceDataPreview, setShowCommServiceDataPreview] = useState({
        show: false,
        data: {}
    });
    const [loadarState, setLoadarState] = useState(false);
    const [daySelected, setDaySelected] = useState("")

    useEffect(() => {
        setLogListPopup(prev => ({
            ...prev,
            startDate: fromDate,
            endDate: toDate
        }));
    }, [fromDate, toDate]);

    const handleServiceType = (value) => {
        setServiceType(value);
        const obj = {
            ListData: [],
            totalCount: 0,
            currentPage: 1,
            commType: '',
            startDate: fromDate,
            endDate: toDate
        }
        setLogListPopup(obj);
        if (value == "main") {
            GetUserCommunicationTypeByDateFn(obj, 1)
        } else if (value == "communication") {
            const newobj = { ...obj, currentPage: 0 };
            getAppUsercommunicationLogsListFn(newobj, 0, daySelected)
        }

    };

    const handlePopupFilter = (e, filterType) => {
        const value = e.target.value;
        if (filterType === "startDate") {
            dispatch({ type: FILTER_ACTION, payload: { fromDate: value } });
        } else if (filterType === "endDate") {
            dispatch({ type: FILTER_ACTION, payload: { toDate: value } });
        }
        setLogListPopup(prev => ({
            ...prev,
            [filterType]: value
        }));
    };


    const handleLogListPagechange = (event, page) => {
        setLogListPopup(prev => ({
            ...prev,
            currentPage: page
        }));
        GetUserCommunicationTypeByDateFn(LogListPopup, page);
    };

    const handlecommServiceLogsList = (event, page) => {
        const adjustedPage = page - 1;
        getAppUsercommunicationLogsListFn(LogListPopup, adjustedPage, daySelected);
    };

    const handlePreview = (show, data = {}) => {
        setShowCommServiceDataPreview({
            show,
            data
        });
    };

    const formatDateLatest = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    };

    const GetUserCommunicationTypeByDateFn = (payload, currentPage) => {
        const s = moment(payload?.startDate).format("DD-MM-YYYY");
        const e = moment(payload?.endDate).format("DD-MM-YYYY");
        setLoadarState(true)
        GetUserCommunicationTypeByDate(s, e, payload?.commType, currentPage, itemsPerPage, callback => {
            setLoadarState(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setLogListPopup((prev) => ({
                    ...prev,
                    ListData: callback?.data,
                    currentPage: currentPage,
                    commType: payload?.commType,
                    startDate: payload?.startDate,
                    endDate: payload?.endDate
                }))
            } else {
                setLogListPopup((prev) => ({
                    ...prev,
                    ListData: callback?.data,
                    currentPage: currentPage,
                    commType: payload?.commType,
                    startDate: payload?.startDate,
                    endDate: payload?.endDate
                }))
            }
        })
        GetUserCommunicationCountTypeByDateFn(payload)
    }
    const GetUserCommunicationCountTypeByDateFn = (payload) => {
        const s = moment(payload?.startDate).format("DD-MM-YYYY");
        const e = moment(payload?.endDate).format("DD-MM-YYYY");
        setLoadarState(true)
        GetUserCommunicationCountTypeByDate(s, e, payload?.commType, callback => {
            setLoadarState(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setLogListPopup(prev => ({
                    ...prev,
                    totalCount: callback?.data,
                }))
            } else {
                setLogListPopup(prev => ({
                    ...prev,
                    totalCount: 0,
                }))
            }
        })
    }

    const getAppUsercommunicationLogsListFn = (payload, currentPage, selectedDay) => {
        const s = moment(payload?.startDate).format("DD-MM-YYYY");
        const e = moment(payload?.endDate).format("DD-MM-YYYY");
        setLoadarState(true)
        getAppUsercommunicationLogsList(currentPage, itemsPerPage, payload?.commType, s, e, selectedDay, callback => {
            setLoadarState(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setLogListPopup({
                    ListData: callback?.data?.content,
                    totalCount: callback?.data?.totalElements,
                    currentPage: currentPage,
                    commType: payload?.commType,
                    startDate: payload?.startDate,
                    endDate: payload?.endDate
                })
            } else {
                setLogListPopup({
                    ListData: [],
                    totalCount: 0,
                    currentPage: currentPage,
                    commType: payload?.commType,
                    startDate: payload?.startDate,
                    endDate: payload?.endDate
                })
            }
        })
    }

    useEffect(() => {
        GetUserCommunicationTypeByDateFn(LogListPopup, 1)
    }, []);


    const handledays = (value) => {
        const dayselectvalue = daySelected == value ? "" : value
        setDaySelected(dayselectvalue)
        getAppUsercommunicationLogsListFn(LogListPopup, 0, dayselectvalue);
    }

    return (
        <>
            <div className="background-blur">

                <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: 'auto', top: '1%' }}>
                    <i onClick={() => handleLogListPopup(false)} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                    <div>
                        <h4 className='text-center'>Communication Logs List &nbsp;(Total Counts: {LogListPopup?.totalCount})</h4>
                    </div>
                    <div className="row" style={{ marginTop: '40px' }}>

                        <div className="col-sm-3 col-xs-12">
                            <label htmlFor="">Filter</label>
                            <select className='form-control' value={serviceType} onChange={(e) => handleServiceType(e.target.value)}>
                                <option value="">Select Communication Service</option>
                                <option value="main">Main</option>
                                <option value="communication">Communication</option>
                            </select>
                        </div>


                        <div className="col-sm-3 col-xs-12">
                            <label htmlFor="">Communication Type</label>
                            <select className='form-control' value={LogListPopup?.commType} onChange={(e) => handlePopupFilter(e, "commType")}>
                                <option value="">Select Communication Type</option>
                                {
                                    serviceType == "main" ?
                                        <>
                                            <option value="mail">Mail</option>
                                            <option value="call">Call</option>
                                            <option value="sms">SMS</option>
                                        </>
                                        : serviceType == "communication" ?
                                            <>
                                                <option value="EMAIL">Mail</option>
                                                <option value="SMS">SMS</option>
                                                <option value="WHATSAPP">Whatsapp</option>
                                                <option value="CALL">Call</option>
                                            </>
                                            : ''}
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Start Date</label>
                            <input type="date" className='form-control' value={LogListPopup?.startDate} onChange={(e) => handlePopupFilter(e, "startDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">End Date</label>
                            <input type="date" className='form-control' value={LogListPopup?.endDate} onChange={(e) => handlePopupFilter(e, "endDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            {
                                serviceType == "main" ?
                                    <button className='btn btn-primary' onClick={() => GetUserCommunicationTypeByDateFn(LogListPopup, 1)} style={{ marginTop: '22px', padding: '10px' }}>Apply Filter</button>
                                    : serviceType == "communication" ?
                                        <button className='btn btn-primary' onClick={() => getAppUsercommunicationLogsListFn(LogListPopup, 0, daySelected)} style={{ marginTop: '22px', padding: '10px' }}>Apply Filter</button>
                                        : ''}
                        </div>

                    </div>
                    {
                        serviceType == "communication" ?

                            <div style={{ marginTop: '20px', display: 'flex' }}>
                                {
                                    dayObj?.map((value, id) => {
                                        return (
                                            <div className="" key={id} style={{ padding: id == 0 ? "0 0 0 15px" : '0 3px' }}>
                                                <h5 className={`customDayBtn ${daySelected === value?.value ? "active" : ""}`}
                                                    onClick={() => handledays(value?.value)}
                                                >
                                                    {value?.name}
                                                </h5>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            : ''}

                    <hr style={{ marginBottom: '5px' }} />

                    {loadarState == false && serviceType == "main" ?
                        <>

                            <div>
                                <div className='customFinanceTable'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Name</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Mobile Number</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Email ID</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Communication Message</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Form Status</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Added By</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Added At</th>
                                            </tr>
                                        </thead>
                                        <tbody className="custom-divide-y">
                                            {LogListPopup && LogListPopup?.ListData?.length > 0 && LogListPopup?.ListData?.map((data, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}>{data?.name || "-"}</td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.mobileNumber || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.emailId || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.body || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.formStatus || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.empId || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {formatDateLatest(data?.addedAt) || "-"} </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <Pagination
                                        count={Math.ceil(LogListPopup?.totalCount / itemsPerPage)}
                                        page={LogListPopup?.currentPage}
                                        onChange={handleLogListPagechange}
                                        color="primary" style={{ display: 'flex', justifyContent: 'end' }}
                                        shape="rounded"
                                    />
                                </div>
                            </div>
                        </>
                        :
                        loadarState == false && serviceType == "communication" ?

                            <div>
                                <div className='customFinanceTable'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Name</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Mobile Number</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Email ID</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Communication Type</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Form Status</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Configured Day</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Configured Time</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Added By</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Added At</th>
                                                <th style={{ fontSize: '13px' }} className='text-center'>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody className="custom-divide-y">
                                            {LogListPopup && LogListPopup?.ListData?.length > 0 && LogListPopup?.ListData?.map((data, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}>{data?.name || "-"}</td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.mobileNumber || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.emailId || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.communicationType || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.formStatus || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.configureDay || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.configureTime || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {data?.addedBy || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}> {formatDateLatest(data?.addedAt) || "-"} </td>
                                                        <td style={{ fontSize: '11px', padding: '10px' }}>
                                                            <i className='fa fa-eye' onClick={() => handlePreview(true, data)}></i>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <Pagination
                                        count={Math.ceil(LogListPopup?.totalCount / itemsPerPage)}
                                        page={Number(LogListPopup?.currentPage + 1)}
                                        onChange={handlecommServiceLogsList}
                                        color="primary" style={{ display: 'flex', justifyContent: 'end' }}
                                        shape="rounded"
                                    />
                                </div>

                                {
                                    showCommServiceDataPreview?.show == true ?
                                        <div className="background-blur">
                                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '600px', top: showCommServiceDataPreview?.data?.communicationType == "EMAIL" ? "5%" : '15%' }}>
                                                {showCommServiceDataPreview?.data?.communicationType == "WHATSAPP" ?
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: showCommServiceDataPreview?.data?.body
                                                                ?.replace(/\n/g, '<br/>')
                                                        }}
                                                    />
                                                    :
                                                    showCommServiceDataPreview?.data?.communicationType == "SMS" ?
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: showCommServiceDataPreview?.data?.body

                                                            }}
                                                        />
                                                        :
                                                        showCommServiceDataPreview?.data?.communicationType == "EMAIL" ?
                                                            <div style={{ height: '500px', overflowY: 'auto' }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: showCommServiceDataPreview?.data?.body
                                                                }}
                                                            />
                                                            : ''}

                                                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                                    <button className='btn btn-primary' onClick={() => handlePreview(false, {})}>Close</button>
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
                            </div>

                            : <DotLoader />
                    }

                </div>
            </div>
        </>
    )
}
